import { httpClient } from '../http/httpClient'

export async function RefuseWithdraw(id: string) {
  const { data } = await httpClient.patch(`/withdraw/${id}/refuse`)

  return data
}
